<template>
  <div>
    <div class="activity-item">
      <div class="left">
        <span class="point">
          <!-- <span class="point-inner"> </span> -->
        </span>
        <div class="item-title">{{ title }}</div>
        <div class="item-desc">{{ description }}</div>
        <div class="item-desc" v-if="description1">{{ description1 }}</div>
      </div>
      <div class="right">
        <div
          class="go-btn flex-center"
          v-if="btnType == 'invite'"
          @click="invite"
        >
          GO
        </div>
        <div
          class="go-btn flex-center"
          v-if="btnType == 'removeException'"
          @click="removeException"
        >
          GO
        </div>
        <div
          class="go-btn flex-center"
          v-if="btnType == 'solution'"
          @click="solution"
        >
          GO
        </div>
        <div
          class="go-btn flex-center"
          v-if="btnType == 'warning'"
          @click="warning"
        >
          GO
        </div>
        <div class="go-btn flex-center" v-if="btnType == 'go'" @click="go">
          GO
        </div>
        <div
          class="waiting-btn flex-center"
          v-if="btnType == 'waiting'"
          @click="waiting"
        >
          敬请期待
        </div>
      </div>
    </div>
    <h-msg-box
      v-model="waitingModal"
      transfer
      customTransferClassName="waitingDialog"
      :closable="false"
      footerHide
      width="600"
    >
      <p slot="header">
        <span>温馨提示</span>
      </p>
      <div style="text-align: center">
        <p class="waiting-content">{{ msgContent }}</p>
      </div>
      <div class="confirm-btn" @click="waitingModal = false">我知道啦</div>
    </h-msg-box>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
  name: '',
  props: {
    // 当前选中的tab
    title: {
      type: String,
      default: ''
    },
    description: {
      type: String,
      default: ''
    },
    // go：直接跳转到对应的活动页面，waiting：敬请期待，warning：一起点评赢大奖提示弹框，invite：邀请有礼提示弹框
    btnType: {
      type: String,
      default: ''
    },
    description1: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      waitingModal: false,
      msgContent: ''
    }
  },
  computed: {
    ...mapGetters(['hsid'])
  },
  created() {},
  mounted() {},
  methods: {
    waiting() {
      this.msgContent = '活动即将开启，敬请期待！'
      this.waitingModal = true
      // 活动按钮点击
      this.buryPoint('U_activePageClick', {
        buttonName_var: '敬请期待'
      })
    },
    go() {
      this.$emit('go')
      // 活动按钮点击
      this.buryPoint('U_activePageClick', {
        buttonName_var: 'go'
      })
    },
    invite() {
      this.msgContent =
        '请在U+ App登录，首页进入“11月狂欢”活动集合\n点击“邀请好友赢U豆”参与活动'
      this.waitingModal = true
      // 活动按钮点击
      this.buryPoint('U_activePageClick', {
        buttonName_var: 'go'
      })
    },
    removeException() {
      this.msgContent =
        '请在U+ App登录，首页进入“11月狂欢”活动集合\n点击“灭异行动”参与活动'
      this.waitingModal = true
      // 活动按钮点击
      this.buryPoint('U_activePageClick', {
        buttonName_var: 'go'
      })
    },
    solution() {
      this.msgContent =
        '请在U+ App登录，首页进入“11月狂欢”活动集合\n点击“解决方案好礼派送”参与活动'
      this.waitingModal = true
      // 活动按钮点击
      this.buryPoint('U_activePageClick', {
        buttonName_var: 'go'
      })
    },
    warning() {
      this.msgContent =
        '请在U+App登录,首页进入-“11月狂欢”活动集合\n点击“一起点评赢大奖”参与活动'
      this.waitingModal = true
      // 活动按钮点击
      this.buryPoint('U_activePageClick', {
        buttonName_var: 'go'
      })
    },
    buryPoint(event, attrs) {
      window.gdp('track', event, {
        deviceType_var: 'Web',
        mobileDeviceId_var: '-',
        appVersionNo_var: '-',
        routeName_var: '11月活动合集',
        activityName_var:this.title,
        appId_var: 5525,
        hsUserId_var: this.hsid || '-',
        ...attrs
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.flex-center {
  display: flex;
  justify-content: center;
  align-items: center;
}
.activity-item {
  background: #fff0ed;
  border: 1px solid rgba(255, 234, 234, 1);
  border-radius: 12px;
  width: 1020px;
  // height: 180px;
  margin: 0 auto 20px;
  padding: 30px;
  padding-bottom: 26px;
  padding-left: 48px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .left {
    position: relative;
    max-width: 740px;
    .point {
      position: absolute;
      left: -23px;
      top: 6px;
      width: 14px;
      height: 14px;
      background-image: linear-gradient(
        180deg,
        #ffe9db 0%,
        #ffadd8 31%,
        #ea5658 100%
      );
      border: 3px solid rgba(255, 245, 244, 1);
      box-shadow: 0px 1px 3px 0px rgba(248, 166, 119, 0.8);
      border-radius: 50%;
    }
    .item-title {
      font-family: PingFangSC-Medium;
      font-size: 30px;
      color: #ab1515;
      letter-spacing: 0;
      line-height: 30px;
      font-weight: 500;
      height: 46px;
    }
    .item-desc,
    .item-sub-desc {
      font-family: PingFangSC-Regular;
      font-size: 24px;
      color: #df7f7f;
      letter-spacing: 0;
      line-height: 40px;
      font-weight: 400;
    }
  }
  .go-btn {
    background-image: linear-gradient(
      180deg,
      #ffe9db 0%,
      #ffadd8 31%,
      #ea5658 100%
    );
    border: 2px solid rgba(255, 245, 244, 1);
    box-shadow: 0px 1px 3px 0px rgba(248, 166, 119, 0.8);
    border-radius: 70px;
    width: 176px;
    height: 50px;
    font-family: PingFangSC-Medium;
    font-size: 32px;
    color: #fff;
    text-align: center;
    line-height: 50px;
    font-weight: 500;
    cursor: pointer;
  }
  .waiting-btn {
    background-image: linear-gradient(180deg, #ffe5ad 0%, #ffb97c 100%);
    border: 1px solid rgba(255, 244, 219, 1);
    box-shadow: 0px 1px 3px 0px rgba(248, 166, 119, 0.8);
    border-radius: 70px;
    font-family: PingFangSC-Medium;
    font-size: 30px;
    color: #ab5c15;
    text-align: center;
    line-height: 50px;
    font-weight: 500;
    width: 176px;
    height: 50px;
    cursor: pointer;
  }
}
/deep/ .waitingDialog {
  .h-modal-header {
    background-image: linear-gradient(180deg, #f9aaa9 0%, #e88482 98%);
    border: 1px solid rgba(238, 143, 141, 1);
    border-radius: 0px 0px 12px 12px;
    margin: 0 auto;
    width: 292px;
    height: 54px;
    padding: 0;
    position: relative;
    top: -1px;
    p {
      font-family: PingFangSC-Medium;
      font-size: 30px;
      color: #fff;
      text-align: center;
      font-weight: 500;
      height: 54px;
      line-height: 54px;
    }
  }
  .h-modal-content {
    background: #fffbf8;
    border: 1px solid rgba(238, 143, 141, 1);
    border-radius: 21.88px;
  }
  .h-modal-body {
    padding-top: 35px;
  }
  .waiting-content {
    font-family: PingFangSC-Medium;
    font-size: 23px;
    color: #df7f7f;
    line-height: 32px;
    font-weight: 500;
    white-space: pre-wrap;
    min-height: 64px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .confirm-btn {
    background-image: linear-gradient(
      180deg,
      #ffe9db 0%,
      #ffadd8 31%,
      #ea5658 100%
    );
    border: 1px solid rgba(255, 245, 244, 1);
    box-shadow: 0px 1px 3px 0px rgba(248, 166, 119, 0.8);
    border-radius: 26px;
    width: 360px;
    height: 53px;
    margin: 35px auto 14px;
    font-family: PingFangSC-Medium;
    font-size: 24px;
    color: #fff;
    text-align: center;
    font-weight: 500;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
  }
}
</style>



// WEBPACK FOOTER //
// src/gtn/views/activities/components/ActivityItem.vue